module.exports = __webpack_public_path__ + "mo/img/ico-benefit10.ed3840b3.png";